/* @flow */
import React from 'react';
import moment from 'moment';
import { DataTable, ListLargeText, ActionButton } from 'listertech-commons-web';

type Props = {
  data: any[],
  onApprove: (id: string) => void,
  onReject: (id: string) => void,
  onSort: (index: number) => void,
};

const PendingUsersTable = (props: Props) => {
  return (
    <DataTable
      name="pending-users"
      headers={[
        { title: 'Name', size: { xs: 2 } },
        { title: 'Email', size: { xs: 3 } },
        { title: 'Discipline', size: { xs: 1 } },
        { title: 'Registered', size: { xs: 2 } },
        { title: 'Actions', size: { xs: 3 } },
      ]}
      data={props.data}
      renderers={[
        (u: any) => <ListLargeText>{u.name}</ListLargeText>,
        (u: any) => <ListLargeText>{u.email}</ListLargeText>,
        (u: any) => <ListLargeText>{u.discipline || '—'}</ListLargeText>,
        (u: any) => (
          <ListLargeText>
            {u.createdAt ? moment(u.createdAt).format('MM/DD/YYYY') : '—'}
          </ListLargeText>
        ),
        (u: any) => (
          <>
            <ActionButton
              key={`verify-${u._id}`}
              onClick={() => props.onApprove(u._id)}
            >
              Approve
            </ActionButton>
            <ActionButton
              orange
              key={`reject-${u._id}`}
              onClick={() => props.onReject(u._id)}
            >
              Reject
            </ActionButton>
          </>
        ),
      ]}
      onSort={props.onSort}
    />
  );
};

export default PendingUsersTable;
